// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"6175":"LazyWUTComponents","6856":"LazyProductQuickAdd"}[chunkId] || chunkId) + ".chunk.min.js";
};